import { LandmarkPair, landmarkDisplayName, LandmarkPoint } from './landmark';

export interface LandmarkPointStructure {
    readonly name: string;
    readonly pointMm: LandmarkPoint['pointMm'];
}

export function landmarkPointStructures(
    pairs: readonly LandmarkPair[],
    frameOfReferenceUid: string | undefined,
    namePrefix: string
): LandmarkPointStructure[] {
    if (!frameOfReferenceUid) {
        return [];
    }
    const structures: LandmarkPointStructure[] = [];
    pairs.forEach((pair, index) => {
        const half = [pair.fixed, pair.moving].find(
            (point) => point?.frameOfReferenceUid === frameOfReferenceUid
        );
        if (half) {
            structures.push({
                name: landmarkDisplayName(
                    pair,
                    index + 1,
                    (ordinal) => `${namePrefix} ${ordinal}`
                ),
                pointMm: half.pointMm,
            });
        }
    });
    return structures;
}
